import script from "./SimpleFIleUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./SimpleFIleUpload.vue?vue&type=script&setup=true&lang=js"

import "./SimpleFIleUpload.vue?vue&type=style&index=0&id=ffa20dc2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffa20dc2"]])

export default __exports__